// src/modules/assetManagement/library/LibraryTeamPages.tsx
// The Events and Products pages (CampaignsAndEvents) shown as Library tabs, next to Assets.
import React from "react";
import { useSelector } from "react-redux";
import type { RootState } from "../../../app/store";
import CampaignsAndEvents from "../../tenant/CampaignsAndEvents";

const useTenant = () => useSelector((state: RootState) => state.tenant.currentTenant);

export const LibraryEvents: React.FC = () => {
  const tenant = useTenant();
  return <CampaignsAndEvents key="events" tenant={tenant} view="events" />;
};

export const LibraryProducts: React.FC = () => {
  const tenant = useTenant();
  return <CampaignsAndEvents key="products" tenant={tenant} view="products" />;
};
